// https://stackoverflow.com/questions/16086162/handle-file-download-from-ajax-post
import { parseFilenameFromContentDisposition } from './download';

function getContentDispositionHeader(headers) {
  if (!headers) {
    return null;
  }
  if (typeof headers.get === 'function') {
    return (
      headers.get('Content-Disposition') ||
      headers.get('content-disposition')
    );
  }
  return headers['content-disposition'] || headers['Content-Disposition'] || null;
}

const postDownload = (response, params = {}) => {
  let filename = '';
  const headers = response.headers;
  const contentDisposition = getContentDispositionHeader(headers);

  if (contentDisposition && contentDisposition.indexOf('attachment') !== -1) {
    filename = parseFilenameFromContentDisposition(contentDisposition);
    // 兼容旧接口：显式要求按 URL 解码且通用解析未得到结果时
    if (!filename && params.decodeType === 'url') {
      const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      const matches = filenameRegex.exec(contentDisposition);
      if (matches != null && matches[1]) {
        try {
          filename = decodeURIComponent(matches[1])
            .replace('utf-8', '')
            .replace(/['"]/g, '');
        } catch {
          filename = '';
        }
      }
    }
  }

  if (params.filename) {
    filename = params.filename;
  }

  if (response.data) {
    const URL = window.URL || window.webkitURL;
    const downloadUrl = URL.createObjectURL(response.data);
    const a = document.createElement('a');
    a.href = downloadUrl;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a = null;
  }

  response.blob &&
    response.blob().then((blob) => {
      if (typeof window.navigator.msSaveBlob !== 'undefined') {
        // IE workaround for "HTML7007: One or more blob URLs were revoked by closing the blob for which they were created.
        // These URLs will no longer resolve as the data backing the URL has been freed."
        window.navigator.msSaveBlob(blob, filename);
      } else {
        const URL = window.URL || window.webkitURL;
        const downloadUrl = URL.createObjectURL(blob);
        if (filename) {
          // use HTML5 a[download] attribute to specify filename
          const a = document.createElement('a');
          // safari doesn't support this yet
          if (typeof a.download === 'undefined') {
            window.location = downloadUrl;
          } else {
            a.href = downloadUrl;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
          }
        } else {
          window.location = downloadUrl;
        }
        setTimeout(function () {
          URL.revokeObjectURL(downloadUrl);
        }, 100); // cleanup
      }
    });

  return response;
};

export default postDownload;
